export default __webpack_public_path__ + "static/media/mercedes-benz.2e3c8281.svg";